// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__3xkFi","normal":"Icon_normal__1247t","fluid":"Icon_fluid__Wh-sY","svg":"Icon_svg__hGZuk"};